import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';

interface IConfirmJobDetailsExitDialogProps {
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Exit guard shown when the office clicks "Back" on Confirm Job Details after
 * editing the pre-filled fields. Mirrors the Review & Payment exit confirmation
 * (same icon, copy, and actions) so the import flow's leave prompt is consistent.
 */
export const ConfirmJobDetailsExitDialog = ({
  onCancel,
  onConfirm,
}: IConfirmJobDetailsExitDialogProps) => (
  <ConfirmPopup
    Icon={() => <OutlineWarning01Icon size={80} color={colors.primary[500]} />}
    leftButtonAction={onCancel}
    leftButtonText="Go Back"
    rightButtonAction={onConfirm}
    rightButtonText="Leave Anyway"
    title="Are You Sure You Want to Leave?"
    titleStyle={{ marginBottom: 20, marginTop: 20 }}
    descriptionStyle={{ marginBottom: 40 }}
    description="Your job isn't posted yet, but we saved it as a draft under Manage Jobs. Do you still want to leave this page?"
  />
);
